import React, { useCallback } from 'react';
import Modal from '../../../shared/modals/modal.component';
import { ScenarioObligation } from '../../../shared/queries/scenarios';

type DeleteScenarioObligationProps = {
  entityToRemove?: ScenarioObligation,
  remove: (arg: { entityToRemove: ScenarioObligation, rowIndex: number }) => void,
  hideModal: () => void,
  rowIndex?: number,
  isVisible: boolean,
  isLoading: boolean,
}

const DeleteScenarioObligation = ({
  entityToRemove,
  hideModal,
  rowIndex,
  remove,
  isVisible,
  isLoading,
}: DeleteScenarioObligationProps) => {
  const onRemove = useCallback(() => {
    if (entityToRemove && typeof rowIndex !== 'undefined' && rowIndex !== null) {
      remove({ entityToRemove, rowIndex });
    }
  }, [entityToRemove, rowIndex, remove]);

  return (
    <Modal
      className="delete-scenario-member"
      dismissText="Cancel"
      submitText="Yes"
      title="Delete Company Code"
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={onRemove}
      isVisible={isVisible}
      isLoading={isLoading}
      isSubmitting={isLoading}
    >
      {
        entityToRemove
          ? (
            <div>
              Are you sure want to delete obligation for
              <br/> Company Code: { entityToRemove.companyCode }
              <br/> Country Code: {entityToRemove.countryCode}
              <br/> Country Tax Type: {entityToRemove.countryTaxType}
            </div>
          )
          : null
      }
    </Modal>
  );
};


export default DeleteScenarioObligation;
